import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
  IWSIBOntarioCode,
  IWSIBOntarioCodeListPayload,
  IWSIBOntarioCodeResponse,
} from "../models";
import {
  IWSIBOntarioRemittance,
  IWSIBOntarioRemittanceListPayload,
  IWSIBOntarioRemittanceResponse,
} from "../models";

import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const WSIBOntarioService = {
  getCodes: async (
    clientId: string,
    taxYear: number,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IWSIBOntarioCodeListPayload
    | IServerError
    | IResponse
    | IWSIBOntarioCodeResponse[]
  > => {
    try {
      const response: AxiosResponse<IWSIBOntarioCodeListPayload> =
        await http.get<IWSIBOntarioCodeListPayload>(
          "/v1/wsib-ontario-code-setup/?client_id=" +
            clientId +
            "&tax_year=" +
            taxYear,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getCodeById: async (
    clientId: string,
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IWSIBOntarioCode | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IWSIBOntarioCode> =
        await http.get<IWSIBOntarioCode>(`/v1/wsib-ontario-code-setup/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createCodes: async (
    requestPayload: any,
  ): Promise<IWSIBOntarioCode | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IWSIBOntarioCode> =
          await http.put<IWSIBOntarioCode>(
            `/v1/wsib-ontario-code-setup/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IWSIBOntarioCode> =
        await http.post<IWSIBOntarioCode>(
          `/v1/wsib-ontario-code-setup/add-wsib-ontario-code`,
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delCodes: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/wsib-ontario-code-setup/${delPayload.codeId}/`,
      );

      if (response.status === 204) {
        return "Codes has been deleted successfully";
      } else if (response.status === 200) {
        return "Codes has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkCodeses: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/codes/`, {
        data: requestPayload.codesIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getCodesDDL: async (
    provinceId: any,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!provinceId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/wsib-ontario-code-setup/wsib-ontario-codes-ddl?province_id=${provinceId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getWSIBOntario: async (
    remittanceFrequencyId: string | undefined,
    clientId: string,
    taxYear: number,
    loadedProfileId: string,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IWSIBOntarioRemittanceListPayload
    | IServerError
    | IResponse
    | IWSIBOntarioRemittanceResponse[]
    | null
  > => {
    if (!remittanceFrequencyId) return null;
    try {
      const response: AxiosResponse<IWSIBOntarioRemittanceListPayload> =
        await http.get<IWSIBOntarioRemittanceListPayload>(
          "/v1/wsib-ontario-remittance/?client_id=" +
            clientId +
            "&remittance_frequency_id=" +
            remittanceFrequencyId +
            "&tax_year=" +
            taxYear +
            "&wsib_profile_id=" +
            loadedProfileId,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 201) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getWSIBOntarioSavedFrequency: async (
    clientId: string,
    taxYear: number,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IWSIBOntarioRemittanceListPayload
    | IServerError
    | IResponse
    | IWSIBOntarioRemittanceResponse[]
    | null
  > => {
    try {
      const response: AxiosResponse<IWSIBOntarioRemittanceListPayload> =
        await http.get<IWSIBOntarioRemittanceListPayload>(
          "/v1/wsib-ontario-remittance/" + clientId + "/?tax_year=" + taxYear,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 201) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  create: async (
    requestPayload: any,
  ): Promise<IWSIBOntarioRemittance | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IWSIBOntarioRemittance> =
        await http.put<IWSIBOntarioRemittance>(
          "/v1/wsib-ontario-remittance/",
          requestPayload,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  createDefaultCode: async (
    requestPayload: any,
  ): Promise<IWSIBOntarioRemittance | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<any>(
          `/v1/wsib-code-profile/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else if (axiosError && axiosError.status === 422) {
          return {
            status: false,
            message: `Errors : \n${format422Errors(
              axiosError?.response?.data,
            )}`,
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }
    try {
      const response: AxiosResponse<IWSIBOntarioRemittance> =
        await http.post<IWSIBOntarioRemittance>(
          "/v1/wsib-code-profile/",
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  delWSIBOntario: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IWSIBOntarioRemittance> =
        await http.delete<IWSIBOntarioRemittance>(
          `/v1/csst-profile/${delPayload.id}/`,
        );

      if (response.status === 204) {
        return "Rate has been deleted successfully.";
      } else if (response.status === 200) {
        return "Rate has been deleted successfully.";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getRemittanceFrequencyDDL: async (): Promise<
    any | IServerError | IResponse | null | any
  > => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/remittance-frequency/remittance-frequency-ddl`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getSavedWSIBDDL: async (
    clientId: string,
    provinceId: string,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!provinceId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/wsib-code-profile/wsib-code-profile-ddl?client_id=${clientId}&province_id=${provinceId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getDefaultCodeProfileDDL: async (): Promise<
    any | IServerError | IResponse | null | any
  > => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/csst-profile/csst-profile-ddl`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getDefaultCodeProfileDataById: async (
    id: null | string,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!id) return null;
    if (id === "new-rate") return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        // `/v1/wsib-code-setup/${id}/`,
        `/v1/wsib-code-profile/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  createWSIBOntarioFrequency: async (
    remittanceFrequencyId: string | undefined,
    clientId: string,
    taxYear: number,
    loadedProfileId: string,
    navigateToLogout: (path: string) => void,
  ): Promise<IWSIBOntarioRemittance | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IWSIBOntarioRemittance> =
        await http.post<IWSIBOntarioRemittance>(
          `/v1/wsib-ontario-remittance/?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&wsib_profile_id=${loadedProfileId}`,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getDefaultCodeDDL: async (
    clientId: string,
    provinceId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!provinceId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/wsib-ontario-code-setup/company-ddl/${clientId}?province_id=${provinceId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  exportWSIBOntarioRemittanceExcelReport: async (
    clientId: string,
    remittanceFrequencyId: string,
    taxYear: number,
    loadedProfileId: string,
  ): Promise<any | IServerError | IResponse | any> => {
    const url = `/v1/all-remittance-printing/wsib-ontario-remittance-xlsx?client_id=${clientId}&remittance_frequency_id=${remittanceFrequencyId}&tax_year=${taxYear}&wsib_profile_id=${loadedProfileId}`;
    const response: any = await http.get(url, {
      responseType: "arraybuffer",
    });

    if (response.status === 201) {
      return response.data;
    } else if (response.status === 200) {
      return response.data;
    } else if (response.status === 400) {
      const text = new TextDecoder().decode(response.data);
      const responseObject = JSON.parse(text);
      let response400 = {
        ...response,
        data: responseObject,
      };
      return response400;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }
    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
};
